import { render, staticRenderFns } from "./roomAdd.vue?vue&type=template&id=69b6f886&scoped=true&"
import script from "./roomAdd.vue?vue&type=script&lang=js&"
export * from "./roomAdd.vue?vue&type=script&lang=js&"
import style0 from "./roomAdd.vue?vue&type=style&index=0&id=69b6f886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b6f886",
  null
  
)

export default component.exports